function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-49b8e521\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=styles&index=0!./cell.vue")
}
var normalizeComponent = require("!../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"plugins\":[[\"babel-plugin-transform-modules\",{\"cube-ui\":{\"transform\":\"cube-ui/src/modules/${member}\",\"kebabCase\":true}}]]}!../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./cell.vue"
import __vue_script__ from "!!babel-loader?{\"plugins\":[[\"babel-plugin-transform-modules\",{\"cube-ui\":{\"transform\":\"cube-ui/src/modules/${member}\",\"kebabCase\":true}}]]}!../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=script&index=0!./cell.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-49b8e521\",\"hasScoped\":false,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../node_modules/_vue-loader@13.7.3@vue-loader/lib/selector?type=template&index=0!./cell.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/cell/cell.vue
// module id = null
// module chunks = 